/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

// Define keys
const KEY_ORGANIZATION_ID = "organization_id";
const KEY_ACCESS_TOKEN = "access_token";

/**
 * Store a value in localStorage.
 * @param {string} key - The key to store.
 * @param {*} value - The value to store (will be stringified).
 */
function store(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error storing value for key "${key}":`, error);
  }
}

/**
 * Retrieve a value from localStorage.
 * @param {string} key - The key to retrieve.
 * @returns {*} Parsed value or null if not found/error.
 */
function retrieve(key) {
  const jsonString = localStorage.getItem(key);
  if (!jsonString) return null;

  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error(`Error parsing value for key "${key}":`, error);
    return null;
  }
}

// Export constants and functions
export {
  KEY_ORGANIZATION_ID,
  KEY_ACCESS_TOKEN,
  store,
  retrieve,
};
